/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsShiftAvailableSlotsOutput } from "../../entities/models/ShiftAvailableSlotsOutput";
import { modelsShiftAvailableDayOutputSchema } from "./shiftAvailableDayOutputSchema";
import { z } from "zod/v4";

export const modelsShiftAvailableSlotsOutputSchema = z.object({
    get "days"(){
                return z.array(modelsShiftAvailableDayOutputSchema).optional()
              },
"from": z.optional(z.string()),
"to": z.optional(z.string())
    }) as unknown as z.ZodType<ModelsShiftAvailableSlotsOutput>